import { takeEvery, put, call, select } from "redux-saga/effects";
import { types } from "../reducers/admin";
import { AdminService } from "../../services";
import { StorageManager } from "datastake-daf/src/helpers/StorageManager";
import { getInterface } from "../../helpers/user";

function* getUsers({ value, callback }) {
  try {
    const { signal, ...props } = value;
    const { data } = yield call(() => AdminService.users(props, signal));
    if (data) {
      yield put({ type: types.USERS_REQUEST_SUCCEDDED, value: data });
    }
  } catch (e) {
    const {
      response: {
        data: { errors },
      },
    } = e;
    if (errors.length > 0) {
      const formattedErrors = {};
      errors.forEach((error) => {
        Object.assign(formattedErrors, {
          [error.property]: Object.values(error.constraints),
        });
      });
      yield put({
        type: types.USERS_REQUEST_FAILED,
        value: formattedErrors,
      });
      return;
    }
  }

  if (typeof callback === 'function') {
    callback();
  }
}

function* getUserDetails({ value }) {
  try {
    const { data } = yield call(() => AdminService.userDetails(value));
    if (data) {
      yield put({ type: types.USERS_DETAIL_REQUEST_SUCCEDDED, value: data });
    }
  } catch (e) {
    yield put({
      type: types.USERS_DETAIL_REQUEST_FAILED,
    });
    return;
  }
}
function* confirmUser({ value: { id, values, callback } }) {
  try {
    const { values: _values, isBlocked } = values;
    const { data } = yield call(() => AdminService.updateAccountAccess(id, _values));

    if (isBlocked) {
      yield call(() => AdminService.disableCompany(id));
    }

    if (callback) {
      callback(false, data);
    }
  } catch (e) {
    console.log(e);
  }
}

function* getStats(value) {
  try {
    const { data } = yield call(() => AdminService.getStats(value));
    if (data) {
      yield put({ type: types.USERS_STATS_SUCCEDDED, value: data });
    }
  } catch (e) {
    console.log(e)
    yield put({
      type: types.USERS_DETAIL_REQUEST_FAILED,
    });
    return;
  }
}

function* getDeletions({ value, callback }) {
  try {
    const { data } = yield call(() => AdminService.getDeletions(value));
    if (data) {
      yield put({ type: types.DELETIONS_REQUEST_SUCCEDDED, value: data });
    }
    callback();
  } catch (e) {
    console.log(e)
    callback();
    yield put({
      type: types.DELETIONS_REQUEST_FAILED,
    });
    return;
  }
}

function* getGlobals({ value: entity, callback, params }) {
  try {
    const { data } = yield call(() => AdminService.getGlobals(entity, params));
    if (data) {
      yield put({ type: types.GET_GLOBALS_SUCCEDDED, value: { view: entity, data } });
      callback();
    }
  } catch (e) {
    console.log(e)
    yield put({
      type: types.GET_GLOBALS_SUCCEDDED, value: {
        view: entity,
        data: {
          data: [],
          options: {},
          totalItems: 0,
        }
      }
    });
    callback();
    return;
  }
}

function* updateGlobal({ value, callback = () => { }, errorCallback = () => { } }) {
  try {
    const { data } = yield call(() => AdminService.updateGlobal(value.entity, value.payload));
    if (data) {
      yield put({ type: types.UPDATE_GLOBAL_SUCCEDDED, value: { view: value.entity, data } });
      callback();
    }
  } catch (e) {
    errorCallback(e.response || e)
    return;
  }
}

function* mergeUser({ value, callback = () => { }, errorCallback = () => { } }) {
  try {
    const { data } = yield call(() => AdminService.mergeUser(value.payload));
    if (data) {
      callback();
    }
  } catch (e) {
    errorCallback(e.response || e)
    return;
  }
}

function* mergeGlobal({ value, callback = () => { }, errorCallback = () => { } }) {
  try {
    const { data } = yield call(() => AdminService.mergeGlobal(value.entity, value.payload));
    if (data) {
      // yield put({ type: types.MERGE_GLOBAL_SUCCEDDED, value: { view: value.entity, data } });
      callback();
    }
  } catch (e) {
    errorCallback(e.response || e)
    return;
  }
}

function* checkMergeGlobal({ value, callback = () => { }, errorCallback = () => { } }) {
  try {
    const { data } = yield call(() => AdminService.checkMergeGlobal(value.entity, value.payload));
    if (data) {
      // yield put({ type: types.MERGE_GLOBAL_SUCCEDDED, value: { view: value.entity, data } });
      callback(data);
    }
  } catch (e) {
    errorCallback(e.response || e)
    return;
  }
}

function* impersonate({ value, mod, app = {} }) {
  try {
    const { user } = yield select((state) => state.authentication);

    const {
      data: { token, ...data },
    } = yield call(() => AdminService.impersonate(value));

    if (token) {
      let _modules = (data.user?.company?.apps || []).map((m) => {
        return { id: getInterface({ app: m, data: m }) }
      });

      const link = process.env.REACT_APP_DEFAULT_APP_LINK || app?.appLink;

      if (link) {
        window.location = `${link}/app-redirect?module=${mod}&token=${token}&prev=true`;
        return;
      }

      StorageManager.set("token", token);

      if (user) {
        StorageManager.set("previous", JSON.stringify(user));
      }

      if (mod) {
        window.location = `/app/${mod}`;
      } else if (_modules.length === 1) {
        window.location = `/app/${_modules[0].id}`;
      } else {
        window.location = "/app";
      }

      yield put({
        type: types.IMPERSONATE_SUCCEDDED,
        value: data
      });
    }
  } catch (e) {
    console.log(e);
    yield put({
      type: types.IMPERSONATE_FAILED,
    });
    return;
  }
}

export default function* init() {
  yield takeEvery(
    types.USERS_REQUESTED,
    getUsers,
  );
  yield takeEvery(
    types.USERS_DETAIL_REQUESTED,
    getUserDetails,
  );
  yield takeEvery(
    types.USER_CONFIRMATION_REQUEST,
    confirmUser,
  );
  yield takeEvery(
    types.USERS_STATS_REQUESTED,
    getStats
  );
  yield takeEvery(
    types.IMPERSONATE_REQUEST,
    impersonate,
  );
  yield takeEvery(
    types.DELETIONS_REQUESTED,
    getDeletions,
  );
  yield takeEvery(
    types.GET_GLOBALS_REQUESTED,
    getGlobals,
  );
  yield takeEvery(
    types.UPDATE_GLOBAL_REQUESTED,
    updateGlobal,
  );
  yield takeEvery(
    types.MERGE_GLOBAL_REQUESTED,
    mergeGlobal,
  );
  yield takeEvery(
    types.MERGE_USER_REQUESTED,
    mergeUser,
  );
  yield takeEvery(
    types.CHECK_MERGE_GLOBAL_REQUESTED,
    checkMergeGlobal,
  );
}
